var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("\n  Copyright © 2013-2020 微影邦 版权所有 苏ICP备18020507号 0512-36881897️\n")])}
var staticRenderFns = []

export { render, staticRenderFns }